<script setup lang="ts">
const testimonials = [
  {
    id: 1,
    name: 'Sarah Johnson',
    role: 'Restaurant Owner',
    company: 'The Fresh Kitchen',
    image: '/testimonials/sarah.jpg',
    content: 'Switching to this POS system has transformed how we run our restaurant. The inventory management is seamless, and our staff learned to use it in no time.',
    rating: 5
  },
  {
    id: 2,
    name: 'Michael Chen',
    role: 'Retail Manager',
    company: 'Urban Styles',
    image: '/testimonials/michael.jpg',
    content: 'The integrated accounting features have saved us countless hours. Real-time sales tracking and financial reports help us make better business decisions.',
    rating: 5
  },
  {
    id: 3,
    name: 'Emily Rodriguez',
    role: 'Store Owner',
    company: 'Wellness Market',
    image: '/testimonials/emily.jpg',
    content: 'Customer support is exceptional. The system is reliable, and when we need help, the team is always there. Best business decision weve made.',
    rating: 5
  }
]

const renderStars = (rating: number) => {
  return '⭐'.repeat(rating)
}
</script>

<template>
  <section class="py-16 bg-gray-50 dark:bg-gray-800/50">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="text-center mb-12">
        <h2 class="text-3xl font-bold text-gray-900 dark:text-white mb-4">
          Trusted by Businesses Everywhere
        </h2>
        <p class="text-lg text-gray-600 dark:text-gray-400">
          See what our customers have to say about their experience
        </p>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
        <div
          v-for="testimonial in testimonials"
          :key="testimonial.id"
          class="bg-white dark:bg-gray-800 rounded-xl shadow-lg p-8 relative"
        >
        

          <!-- Content -->
          <div class="mb-6">
            <p class="text-gray-600 dark:text-gray-300 italic">
              "{{ testimonial.content }}"
            </p>
          </div>

          <!-- Rating -->
          <div class="mb-4 text-yellow-400">
            {{ renderStars(testimonial.rating) }}
          </div>

          <!-- Author -->
          <div class="flex items-center">
            <div class="w-12 h-12 rounded-full bg-gray-200 dark:bg-gray-700 flex items-center justify-center text-gray-500 dark:text-gray-400 text-xl">
              👤
            </div>
            <div class="ml-4">
              <h4 class="font-semibold text-gray-900 dark:text-white">
                {{ testimonial.name }}
              </h4>
              <p class="text-sm text-gray-600 dark:text-gray-400">
                {{ testimonial.role }} at {{ testimonial.company }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>